export default "__VITE_ASSET__DGGw$12y__"